
import Vue from "vue";
import { Domicilio } from '@/models/Domicilio';
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import CustomFile from "@/components/Common/CustomFile.vue";
import CatastroService from '@/services/CatastroService';
import AlertasPredial from '@/components/Solicitudes/AlertasPredial.vue';
import EventBus from "@/plugins/event-bus";
import CambioDomicilioService from '@/services/CambioDomicilioService';
import { CambioDomicilio } from "@/models/CambioDomicilio";
import EstablecimientoService from '@/services/EstablecimientoService';

export default Vue.extend({
    name: 'CambioDomicilio',
    components: {
        Direccion,
        CustomFile,
        AlertasPredial,
    },
    props: {
        establecimiento: {
            default: null as any,
        },
        dialogPrincipal: {
            type: Boolean,
        },
        deleteSolicitud: {
            type: Boolean,
            default: false,
        },
        disabledForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            dialogCatastro: false,
            disabledPredial: false,
            dialogClaveCatastral: false,
            dialogView: false,
            dialogPredial: false,
            dialogBusqueda: false,
            documento: {} as any,
            formData: {} as any,
            formDataNueva: new CambioDomicilio(),
            disabled: false,
            solicitudes: [] as any,
            solicitud: {} as any,
            idSolicitud: null,
            dialogDelete: false,
            tipoPropiedades: [],
        }
    },
    watch: {
        dialogPrincipal: {
            handler(newVal) {
                if (this.dialogPrincipal) {
                    this.verSolicitud();
                    this.getTiposPredios();
                }
            },
            deep: true,
        },
        'formDataNueva.donativo': {
            handler(value) {
                if (value) {
                    this.formDataNueva.clave_catastral = 'DONATIVO';
                    if (!this.solicitud) {
                        this.disabled = false;
                    }
                    this.dialogCatastro = false;
                } else {
                    this.formDataNueva.clave_catastral = '';
                }
            },
            deep: true,
        },
        dialog() {
            if (this.dialog) {
                if (!this.formDataNueva.id) {
                }
                this.getDataDomicilio(this.establecimiento.id);
            }
        },
        disabledForm() {
            this.disabled = this.disabledForm;
        }
    },
    methods: {
        agregarSolicitud() {
            this.dialogBusqueda = true;
        },
        closeDialogCatastro() {
            this.dialogCatastro = false;
            this.disabled = false;
            this.formDataNueva = new CambioDomicilio();
            this.disabledPredial = false;
            this.$emit('close');
        },
        closeDialogClaveCatastral(e: any) {
            this.dialogClaveCatastral = false;
            if (e) {
                this.dialog = true;
                this.disabled = false;
            } else {
                this.closeDialogCatastro();
            }
        },
        closeDialogPredial() {
            this.dialogPredial = false;
        },
        closeDialog() {
            this.dialogCatastro = false;
            this.dialog = false;
            this.disabledPredial = false;
            this.solicitud = {};
            this.formDataNueva = new CambioDomicilio();
            this.$emit('close');
        },
        async consultarCatastro() {
            /*let { data: { resultados: catastro } } = await CatastroService.searchByClaveCatastral(this.formDataNueva.clave_catastral);
            if (catastro != false) {
                this.formDataNueva.domicilio.codigo_postal = catastro.cp.toString();
                this.formDataNueva.domicilio.localidad_id = catastro.id_localidad;
                this.formDataNueva.domicilio.colonia_id = catastro.id_colonia;
                this.formDataNueva.domicilio.calle_id = catastro.id_calle;
                this.formDataNueva.domicilio.numero_exterior = catastro.num_predio;*/
                let { data } = await EstablecimientoService.getPagoPredial(this.formDataNueva.clave_catastral);
                if (data.data) {
                    this.disabled = false;
                    this.disabledPredial = true;
                    this.dialogCatastro = false;
                    this.getDataDomicilio(this.establecimiento.id);
                    this.dialog = true;
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message)
                    this.dialogPredial = true;
                }
            /*} else {
                this.$toast.error("La clave no ha sido encontrada en catastro")
            }*/
        },
        openDialogClaveCatastral(event: any) {
            if (event)
                this.dialogClaveCatastral = true
        },
        getDataDomicilio(id: any) {
            CambioDomicilioService.getDataDomicilio(id)
                .then((response) => {
                    this.formData = {
                        ...this.formData,
                        domicilio: response.data.locacion_domicilio.domicilio
                    };
                })
        },
        setDomicilio(domicilio: Domicilio) {
            this.formData.domicilio = Object.assign({}, domicilio);
        },
        setDomicilioNueva(domicilio: Domicilio) {
            this.formDataNueva.domicilio = Object.assign({}, domicilio);
        },
        cerrar() {
            this.disabled = false;
            this.formDataNueva = new CambioDomicilio();
            this.$emit('close', this.dialog);
        },
        async guardarSolicitud(item: any) {
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                EventBus.$emit("update-direccion");
                const formData = this.objectFormData(this.formDataNueva);
                await CambioDomicilioService.setSolicitudCambioDomicilioExtra(item.id, formData)
                    .then(async (response) => {
                        this.$toast.success(response.data.message);
                        let solicitud = response.data.data;
                        let formDataPredial = new FormData();
                        let formDataFotos = new FormData();
                        //@ts-ignore
                        formDataPredial = this.objectToFormData(this.formDataNueva.predial, formDataPredial)
                        formDataPredial.append('solicitud_id', solicitud.id);

                        const responseFilesPredial = await CambioDomicilioService.storeFilesExtra(item.id, solicitud.id, formDataPredial)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Documentos adjuntados con exito");
                                }
                            })

                        //@ts-ignore
                        formDataFotos = this.objectToFormData(this.formDataNueva.fotos, formDataFotos)
                        formDataFotos.append('solicitud_id', solicitud.id);

                        const responseFilesFotos = await CambioDomicilioService.storeFilesExtra(item.id, solicitud.id, formDataFotos)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Fotos adjuntados con exito");
                                }
                            })
                        this.$emit('reloadData');
                        this.verSolicitud();
                    })
                    .catch((error) => {
                        //this.$toast.error(error.response.data.message);
                    })
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        objectFormData(data: any) {
            const formData = new FormData();
            formData.append(`id`, data.id);
            formData.append(`clave_catastral`, data.clave_catastral);
            formData.append(`donativo`, data.donativo ? 1 : 0 as any);
            formData.append(`numero_oficio_constancia_catastro`, data.numero_oficio_constancia_catastro ? data.numero_oficio_constancia_catastro : '');
            formData.append(`folio_recibo_pago_donativo`, data.folio_recibo_pago_donativo ? data.folio_recibo_pago_donativo : '');
            formData.append(`renovacion`, data.renovacion as any ? 1 : 0 as any);

            formData.append(`has_licencia_bebidas`, data.has_licencia_bebidas as any ? 1 : 0 as any);
            formData.append(`patente_propia`, data.patente_propia ? 1 : 0 as any);
            formData.append(`folio_licencia_bebida_alcoholica`, data.folio_licencia_bebida_alcoholica ? data.folio_licencia_bebida_alcoholica : '');

            formData.append(`has_alcohol`, this.hasAlcohol ? 1 : 0 as any);
            formData.append(`tipo_proceso_id`, data.tipo_proceso_id ? data.tipo_proceso_id : '');
            formData.append(`tipo_propiedad_id`, data.tipo_propiedad_id ? data.tipo_propiedad_id : '');

            Object.entries(data.domicilio).forEach(([key, value]) => {
                let v = value as any;
                if (key == 'otro_domicilio') {
                    Object.entries(v).forEach(([key2, val]) => {
                        let d = val as any;
                        const baseKey2 = `domicilio[otro_domicilio][${key2}]`;
                        if (key2 == 'is_otra_colonia') {
                            formData.append(`${baseKey2}`, d ? 1 : 0 as any);
                        } else {
                            formData.append(`${baseKey2}`, d ? d : '');
                        }
                    });
                } else {
                    const baseKey = `domicilio[${key}]`;
                    formData.append(`${baseKey}`, v ? v : '');
                }
            });

            Object.entries(data.documentos).forEach(([key, documento]) => {
                let d = documento as any;
                const baseKey = `files[${key}]`;
                formData.append(`${baseKey}[file]`, d.file);
                formData.append(`${baseKey}[code]`, key);
            });

            return formData;
        },
        verSolicitud() {
            CambioDomicilioService.getSolicitudCambioDomicilioExtra(this.establecimiento.id)
                .then((response) => {
                    let solicitud = response.data.data;
                    if (solicitud) {
                        this.solicitud = solicitud;
                        this.formDataNueva.id = solicitud.id;
                        this.formDataNueva.clave_catastral = solicitud.clave_catastral;
                        this.formDataNueva.donativo = solicitud.donativo == 1 ? true : false;
                        this.formDataNueva.numero_oficio_constancia_catastro = solicitud.numero_oficio_constancia_catastro;
                        this.formDataNueva.folio_recibo_pago_donativo = solicitud.folio_recibo_pago_donativo;
                        this.formDataNueva.renovacion = solicitud.renovacion ? 1 : 0;
                        this.formDataNueva.folio_licencia_bebida_alcoholica = solicitud.folio_licencia_bebida_alcoholica;
                        this.formDataNueva.has_alcohol = solicitud.has_alcohol ? true : false;
                        this.formDataNueva.tipo_proceso_id = solicitud.tipo_proceso_id;
                        this.formDataNueva.tipo_propiedad_id = solicitud.tipo_propiedad_id;
                        this.formDataNueva.patente_propia = solicitud.patente_propia == 1 ? true : false;
                        this.setFiles(solicitud);

                        this.formDataNueva.domicilio = {
                            ...solicitud.domicilio,
                        }

                        if (!solicitud.domicilio.otro_domicilio) {
                            let domicilio = new Domicilio();
                            this.formDataNueva.domicilio.otro_domicilio = domicilio.otro_domicilio;
                        }
                    }

                    if (!this.formDataNueva.id) {
                        this.dialogCatastro = true;
                    } else {
                        this.dialog = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })

            if (this.deleteSolicitud) {
                this.dialogDelete = true;
            }
        },
        setFiles(solicitud: any) {
            const fotos = ['frente', 'interior', 'wc', 'lateralDerecho', 'lateralIzquierdo'];

            if (solicitud.constancia_r_s) {
                const rs = solicitud.constancia_r_s;
                this.formDataNueva.documentos['scdd_constancia_rs'].code = 'scdd_constancia_rs';
                this.formDataNueva.documentos['scdd_constancia_rs'].data = rs;
            }

            if (solicitud.saneamiento) {
                const saneamiento = solicitud.saneamiento;
                this.formDataNueva.documentos['scdd_saneamiento'].code = 'scdd_saneamiento';
                this.formDataNueva.documentos['scdd_saneamiento'].data = saneamiento;
            }

            if (solicitud.constancia_donativo) {
                const constanciaDonativo = solicitud.constancia_donativo;
                this.formDataNueva.documentos['constancia_donativo'].code = 'constancia_donativo';
                this.formDataNueva.documentos['constancia_donativo'].data = constanciaDonativo;
            }

            if (solicitud.recibo_pago) {
                const reciboPagoDonativo = solicitud.recibo_pago;
                this.formDataNueva.documentos['recibo_pago_donativo'].code = 'recibo_pago_donativo';
                this.formDataNueva.documentos['recibo_pago_donativo'].data = reciboPagoDonativo;
            }

            if (solicitud.licencia_alcohol) {
                const licenciaAlcohol = solicitud.licencia_alcohol;
                this.formDataNueva.documentos['licencia'].code = 'licencia';
                this.formDataNueva.documentos['licencia'].data = licenciaAlcohol;
            }

            if (solicitud.licencia_bebida) {
                const licenciaBebidas = solicitud.licencia_bebida;
                this.formDataNueva.documentos['pago_licencia_bebidas'].code = 'licencia_bebidas';
                this.formDataNueva.documentos['pago_licencia_bebidas'].data = licenciaBebidas;
            }

            if (solicitud.licencia_comodato) {
                const licenciaComodato = solicitud.licencia_comodato;
                this.formDataNueva.documentos['licencia_comodato'].code = 'licencia_comodato';
                this.formDataNueva.documentos['licencia_comodato'].data = licenciaComodato;
            }

            if (solicitud.aviso_cambio) {
                const avisoCambio = solicitud.aviso_cambio;
                this.formDataNueva.documentos['aviso_cambio'].code = 'aviso_cambio';
                this.formDataNueva.documentos['aviso_cambio'].data = avisoCambio;
            }

            if (solicitud.constancia_uso_suelo) {
                const constanciaUS = solicitud.constancia_uso_suelo;
                this.formDataNueva.documentos['constancia_us_cd'].code = 'constancia_us_cd';
                this.formDataNueva.documentos['constancia_us_cd'].data = constanciaUS;
            }

            let predial: [] = solicitud.predial.filter((archivo: any) => !fotos.includes(archivo.archivo.tipo_archivo)).map((archivo: any) => {
                return {
                    code: archivo.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: archivo.archivo
                }
            });

            const frente = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "frente");
            if (frente != undefined) {
                this.formDataNueva.fotos.frente = {
                    code: frente.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: frente.archivo
                }
            }

            const interior = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "interior");
            if (interior != undefined) {
                this.formDataNueva.fotos.interior = {
                    code: interior.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: interior.archivo
                }
            }
            const wc = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "wc");
            if (wc != undefined) {
                this.formDataNueva.fotos.wc = {
                    code: wc.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: wc.archivo
                }
            }
            const lateralIzquierdo = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "lateralIzquierdo");
            if (lateralIzquierdo != undefined) {
                this.formDataNueva.fotos.lateralIzquierdo = {
                    code: lateralIzquierdo.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: lateralIzquierdo.archivo
                }
            }
            const lateralDerecho = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "lateralDerecho");
            if (lateralDerecho != undefined) {
                this.formDataNueva.fotos.lateralDerecho = {
                    code: lateralDerecho.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: lateralDerecho.archivo
                }
            }

            let finalDocuments = [] as any;

            predial.forEach((element: any, index: any) => {
                if (!finalDocuments.hasOwnProperty(element.code)) {
                    finalDocuments[element.code] = element;
                }
            });

            //@ts-ignore
            this.formDataNueva.predial = {
                ...this.formDataNueva.predial,
                //@ts-ignore
                ...finalDocuments
            };
        },
        async updateSolicitudCambioDomicilio(item: any) {
            EventBus.$emit('update-direccion');
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                const formData = this.objectFormData(this.formDataNueva);
                await CambioDomicilioService.updateSolicitudCambioDomicilioExtra(this.establecimiento.id, item.id, formData)
                    .then(async (response) => {
                        this.$toast.success(response.data.message);
                        let solicitud = response.data.data;
                        let formDataPredial = new FormData();
                        let formDataFotos = new FormData();
                        //@ts-ignore
                        formDataPredial = this.objectToFormData(this.formDataNueva.predial, formDataPredial)
                        formDataPredial.append('solicitud_id', solicitud.id);

                        const responseFilesPredial = await CambioDomicilioService.storeFilesExtra(this.establecimiento.id, item.id, formDataPredial)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Documentos adjuntados con exito");
                                }
                            })

                        //@ts-ignore
                        formDataFotos = this.objectToFormData(this.formDataNueva.fotos, formDataFotos)
                        formDataFotos.append('solicitud_id', solicitud.id);

                        const responseFilesFotos = await CambioDomicilioService.storeFilesExtra(this.establecimiento.id, item.id, formDataFotos)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Fotos adjuntados con exito");
                                }
                            })
                        this.$emit('reloadData');
                        this.verSolicitud();
                    })
                /* .catch((error) => {
                    //this.$toast.error(error.response.data.message);
                }) */
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        deleteSolicitudCambioDomicilioExtra(item: any) {
            CambioDomicilioService.deleteSolicitudCambioDomicilioExtra(this.establecimiento.id, item.id, {})
                .then((response) => {
                    this.$toast.success(response.data.message);
                    let data = response.data.data;
                    this.$emit('reloadData');
                    this.closeDialog();
                    this.dialogDelete = false;
                })
                .catch((error) => {
                    //this.$toast.error(error.response.data.message);
                })
        },
        async getTiposPredios() {
            await EstablecimientoService.getTipoPropiedades().then((response) => {
                this.tipoPropiedades = response.data;
            });
        },
        objectToFormData(obj: any, formData: any) {
            let counterItems = 0;
            Object.entries(obj).forEach(([key, value]) => {
                //@ts-ignore
                formData.append(`documento[${counterItems}][file]`, value.file);
                formData.append(`documento[${counterItems}][code]`, key);
                counterItems++;
            });
            return formData;
        },
    },
    computed: {
        esHoteleria: function () {
            let hasHotel = this.establecimiento.actividades_secundarias.find((item: any) => item.d_giro.includes("HOTEL"));

            if (hasHotel != undefined) {
                return true;
            }

            if (this.establecimiento.giro_opb != null) {
                //@ts-ignore
                if (this.establecimiento.giro_opb?.descripcion) {
                    //@ts-ignore
                    if (this.establecimiento.giro_opb.descripcion.includes("HOTEL") || this.establecimiento.giro_opb.descripcion.includes("MOTEL")) {
                        return true;
                    }
                }
                //@ts-ignore
                if (this.establecimiento.giro_opb?.d_giro) {
                    //@ts-ignore
                    if (this.establecimiento.giro_opb.d_giro.includes("HOTEL") || this.establecimiento.giro_opb.d_giro.includes("MOTEL")) {
                        return true;
                    }
                }
            } else {
                return false;
            }
            return false;
        },
        hasAlcohol: function () {
            let hasPatente = this.establecimiento.actividades_secundarias.find((item: any) => item.req_patente == "SI");

            if (hasPatente != undefined) {
                return true;
            }

            if (this.establecimiento.giro_opb != null) {
                //@ts-ignore
                if (this.establecimiento.giro_opb.req_patente == "SI") {
                    return true;
                }
            } else {
                return false;
            }
            return false;
        },
        isNotOwner() {
            if (this.formDataNueva.tipo_propiedad_id != 1 && this.formDataNueva.tipo_propiedad_id != 4 && this.formDataNueva.tipo_propiedad_id != null) {
                return true;
            }
            return false;
        },
        isBaldio() {
            if (this.formDataNueva.tipo_propiedad_id == 4) {
                return true;
            }
            return false;
        },
    }
})
